export enum Urls {
    AboutPage = 'AboutPage',
    AccountPage = 'AccountPage',
    ArrivalPage = 'ArrivalPage',
    AssignVisitsPage = 'AssignVisitsPage',
    AssignedPatientsVisitsPage = 'AssignPatientVisitsPage',
    CancelVisitPage = 'CancelVisitPage',
    ChangePasswordPage = 'change-password',
    ConfirmDeparturePage = 'ConfirmDeparturePage',
    LoginPage = 'login',
    MainMenuPage = 'main-menu',
    NotificationCenterPage = 'NotificationCenterPage',
    PayrollDetailsPage = 'PayrollDetailsPage',
    PayrollPage = 'PayrollHistoryPage',
    PayrollSummaryPage = 'PayrollSummaryPage',
    WeeklyHoursPage = 'WeeklyHoursPage',
    WeeklySummaryPage = 'WeeklySummaryPage',
    RecordTripsPage = 'RecordTripsPage',
    RecordErrandMilesPage = 'RecordErrandMilesPage',
    ReportMissedVisitTimesPage = 'ReportMissedVisitTimesPage',
    ReportArrivalPage = 'ReportArrivalPage',
    ReportCarePlansPage = 'ReportCarePlansPage',
    ReportDeparturePage = 'ReportDeparturePage',
    NoShowPage = 'NoShowPage',
    SelectServiceTypePage = 'SelectServiceTypePage',
    SettingsPage = 'settings',
    TwoFactorAuthPage = 'TwoFactorAuthPage',
    UnderConstructionPage = 'under-construction',
    UpcomingVisitsPage = 'upcoming',
    UploadTimesheetsPage = 'UploadTimesheetsPage',
    VisitCompletePage = 'VisitCompletePage',
    VisitDetailsBingMaps = 'VisitDetailsBingMaps',
    VisitDetailsPage = 'VisitDetailsPage',
    VisitDocumentsPage = 'VisitDocumentsPage',
    VisitHistoryPage = 'VisitHistoryPage',
    VisitSignaturePage = 'VisitSignaturePage',
    VisitConfirmationPage = 'VisitConfirmationPage',
    WorkerCalendarPage = 'WorkerCalendarPage',
    ChatRoomPage = 'ChatRoomPage',
    CallingPage = 'CallingPage',
    CallScreen = 'CallScreen',
    HoursWantedPage = 'AvailabilityPage',
    ChatViewPage = 'ChatViewPage',
    ChatRoomViewPage = 'ChatRoomViewPage',
    OverrideSchedule ="/AvailabilityPage/override",
    AddSlot ="/AvailabilityPage/addSlot",
    TimeOff ="/AvailabilityPage/timeoff",
    PatientDocuments ="patientDocumentsPage",
    PatientDocumentsDetails ="patientDocumentsDetailsPage",
    ReportDepartureAI ="report-departure-ai",
    ReportExpensesPage = "ReportExpensesPage",
    SignaturePage = "SignaturePage",
    PatientVisitHistoryPage = "PatientVisitHistoryPage",
    AvailableShiftsPage = "AvailableShiftsPage",
    Invitations = "Invitations",
    Requests = "Requests",
    Declined = "Declined",
    Util = "Util",
    POSInfo = 'POSInfo',
    ConsentToReceiveTextPage = 'ConsentToReceiveTextPage',
    ReportBreakPage = 'ReportBreakPage',
}

